var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFE5EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1375_62895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 39.9663C59.45 39.4163 53.8667 39.133 48.3 39.133C45 39.133 41.7 39.2997 38.4 39.633L35 39.9663M44.1667 38.283L44.5333 36.0997C44.8 34.5163 45 33.333 47.8167 33.333H52.1833C55 33.333 55.2167 34.583 55.4667 36.1163L55.8333 38.283M61.4167 45.233L60.3333 62.0163C60.15 64.633 60 66.6663 55.35 66.6663H44.65C40 66.6663 39.85 64.633 39.6667 62.0163L38.5833 45.233M47.2167 57.4997H52.7667M45.8333 50.833H54.1667",
    stroke: "#E60033",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1375_62895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(30 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalDelete);
export default __webpack_public_path__ + "static/media/modal_delete.1811a70209eaf05b31aa42e9ce1fee1c.svg";
export { ForwardRef as ReactComponent };